import axios from '../axios-auth'

export const monthlyCustomerSaleReportService = {
    getMonthlyCustomerSaleReport,
    getAllMonthlyCustomerSaleReport,
    getMonthlyCustomerSaleReportByCategoryGroup,
    getAllMonthlyCustomerSaleReportByCategoryGroup,
}

function getMonthlyCustomerSaleReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.cityId) {
        params["cityId"] = searchParams.cityId;
    }

    return axios.get("/auth/monthly-customer-sale-report", { params });
}

function getAllMonthlyCustomerSaleReport(searchParams) {
    let params = {};

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.cityId) {
        params["cityId"] = searchParams.cityId;
    }

    return axios.get("/auth/monthly-customer-sale-report-print", { params });
}

function getMonthlyCustomerSaleReportByCategoryGroup(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/monthly-customer-sale-report-category-group", { params });
}

function getAllMonthlyCustomerSaleReportByCategoryGroup(searchParams) {
    let params = {};

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/monthly-customer-sale-report-category-group-print", { params });
}